import React from 'react';
import Img1 from '../assets/images/support1.png';
import Img2 from '../assets/images/support2.png';
import Img3 from '../assets/images/support3.png';
import {
    StyledAvatar,
    StyledAvatarGroup,
    GroupWrapper,
    HorizontalDivider,
    GroupConfettiIcon,
    GroupGenerosityIcon,
} from './styles';

export type SupportAvatarGroupProps = {
    compact?: boolean;
};

export const SupportAvatarGroup: React.FCC<SupportAvatarGroupProps> = ({
    compact,
}) => {
    return (
        <GroupWrapper>
            {compact ? null : (
                <>
                    <GroupConfettiIcon variant="confetti-left" />
                    <GroupGenerosityIcon variant="generosity" />
                    <HorizontalDivider />
                </>
            )}
            <StyledAvatarGroup spacing="small">
                <StyledAvatar compact={compact} src={Img1} />
                <StyledAvatar compact={compact} src={Img2} />
                <StyledAvatar compact={compact} src={Img3} />
            </StyledAvatarGroup>
            {compact ? null : <GroupConfettiIcon variant="confetti-right" />}
        </GroupWrapper>
    );
};
